import { supabase } from "@/integrations/supabase/client";
import { AMP_TEMPLATE, getDefaultStructuredData } from "@/lib/amp/constants";
import { prefillPlan } from "@/lib/amp/importer";

export interface CreateAmpPlanArgs {
  projectId: string;
  folderId?: string | null;
  name?: string;
  userId?: string | null;
}

export interface CreateAmpPlanResult {
  planId: string | null;
  sectionsError?: string;
}

/**
 * Skapar en arbetsmiljöplan med alla avsnitt och förifyllning.
 * Delas av projektvyn och det fristående dokumentflödet.
 */
export async function createAmpPlan({
  projectId,
  folderId = null,
  name,
  userId = null,
}: CreateAmpPlanArgs): Promise<CreateAmpPlanResult> {
  const { data, error } = await supabase
    .from("work_environment_plans")
    .insert({
      project_id: projectId,
      folder_id: folderId ?? null,
      name: (name || "").trim() || "Arbetsmiljöplan",
      status: "draft",
      version: 1,
      content_json: {},
      created_by: userId,
      updated_by: userId,
    })
    .select("id")
    .single();

  if (error || !data) {
    return { planId: null };
  }

  const rows = AMP_TEMPLATE.map((section, index) => ({
    project_id: projectId,
    plan_id: data.id,
    section_key: section.key,
    title: section.title,
    status: "not_started",
    legal_reference: section.legalReference,
    sort_order: index,
    body: "",
    content_json: {},
    structured_data: getDefaultStructuredData(section),
    updated_by: userId,
  }));

  const { error: sectionError } = await supabase.from("amp_sections").insert(rows);
  if (sectionError) {
    return { planId: data.id, sectionsError: sectionError.message };
  }

  await prefillPlan(data.id, projectId, userId);
  return { planId: data.id };
}
